// extracted by mini-css-extract-plugin
module.exports = {"subTableHeader":"TableHeader_subTableHeader__JrP-y"};